import { MeResponse, PlanName } from 'base/accounts_service';
import { AccountStore } from 'base/account_store';
import { AnalyticsService } from 'base/analytics';
import { getProjectUrl } from 'base/blocks_routes';
import { ServiceHttpError } from 'base/service_error';
import { Button } from 'base/ui/button';
import { Dialog } from 'base/ui/dialog';
import { formatError } from 'base/ui/form';
import { TextRegularLight } from 'base/ui/typography';
import {
  ProFeatureGateDialog,
  TeamFeatureGateDialog,
} from 'blocks/billing/feature_gate_dialog';
import React from 'react';
import { BlocksService } from './blocks_service';
import styles from './create_project.css';
import { EMPTY_PROJECT } from './editor/default_project';
import { LoadingPage } from './login_wall';

export function CreateProject({
  blocksService,
  brief,
  accountStore,
  analytics,
}: {
  accountStore: AccountStore;
  blocksService: BlocksService;
  analytics: AnalyticsService;
  brief?: string;
}) {
  const [error, setError] = React.useState<unknown>(null);

  React.useEffect(
    () => {
      (async () => {
        const createRes = await blocksService.createProject({
          data: { ...EMPTY_PROJECT, brief },
          owner: 'user',
        });
        // Get query params add generateOnLoad and remove brief and
        const params = new URLSearchParams(window.location.search);
        params.set('generateOnLoad', 'true');
        params.delete('brief');
        // Replace rather than navigate, so the user doesn't accidentally create a 2nd project
        // if they hit the back button.
        window.history.replaceState(
          null,
          '',
          decodeURIComponent(`${getProjectUrl(createRes.token)}?${params}`),
        );
      })().catch((error) => {
        setError(error);
      });
    }, // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <div className={styles.root}>
      {error ? (
        <CreateProjectErrorDialog
          error={error}
          me={accountStore.member}
          onClose={() => window.history.pushState(null, '', '/dashboard')}
          analytics={analytics}
        />
      ) : (
        <LoadingPage />
      )}
    </div>
  );
}
function UnknownErrorDialog({ error }: { error: unknown }) {
  return (
    <Dialog
      title="Error creating project"
      buttons={
        <Button
          variant="primary"
          label="Reload"
          onClick={() => window.location.reload()}
          size="large"
        />
      }
    >
      <TextRegularLight>{`${formatError(error)}`}</TextRegularLight>
      <TextRegularLight>Please refresh the page to try again</TextRegularLight>
    </Dialog>
  );
}

export function CreateProjectErrorDialog({
  me,
  error,
  onClose,
  analytics,
}: {
  me?: MeResponse;
  analytics: AnalyticsService;
  error: unknown;
  onClose: () => void;
}) {
  if (error == null) return null;
  if (error instanceof ServiceHttpError && error.status === 403) {
    const currentPlan = me?.planName || PlanName.FREE;

    // Very crude check for target feature gate
    if (error.toString().includes('project limit')) {
      return (
        <ProFeatureGateDialog
          analytics={analytics}
          currentPlan={currentPlan}
          initialFeatureKey="projects"
          onClose={onClose}
        />
      );
    } else if (error.toString().includes('Upgrade to the Pro plan')) {
      return <TeamFeatureGateDialog analytics={analytics} onClose={onClose} />;
    }
  }

  return <UnknownErrorDialog error={error} />;
}
